<template>
  <div>test</div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        console.log(window.orientation);
      });
    });
  },
};
</script>

<style></style>
